import {
  // organizationClient,
  adminClient,
  anonymousClient,
} from "better-auth/client/plugins";
import { createAuthClient } from "better-auth/react"; // make sure to import from better-auth/react

export const getAuthClient = (config?: { baseURL?: string }) =>
  createAuthClient({
    //you can pass client configuration here
    ...config,
    plugins: [
      anonymousClient(),
      // organizationClient()
      adminClient(),
    ],
  });
